<template>
  <div class="col-12">
    <div class="current-item conf-selection">
      <div class="container-fluid container-menu-options">
        <div class="row">
          <div class="col-1">
            <a
              v-if="!isFirstVarType"
              @click="lastVarType()"
              class="last-item-arrow"
            >
              <svg width="100%" height="100%" viewBox="0 0 400 100">
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M145.188,238.575l215.5-215.5c5.3-5.3,
                     5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
                     c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"
                />
              </svg>
            </a>
          </div>
          <div
            class="col-10 sub-menu text-center no-scrollbar"
            ref="menuOption"
          >
            <ul ref="menuOptionList">
              <template v-for="(menuPoint, index) in fullMenuList">
                <li
                  v-if="
                    index === 'stones' &&
                    !menuList['stones/jewellery/normal'] &&
                    !menuList['stones/jewellery/model']
                  "
                  v-bind:key="index"
                  :class="{ match: currentVarType == index }"
                  :id="'menu-' + index"
                >
                  <a @click="configure(index)">{{ menuPoint }}</a>
                </li>
                <li
                  v-else-if="index !== 'stones'"
                  v-bind:key="index"
                  :class="{ match: currentVarTypeStone == index }"
                  :id="'menu-' + index"
                >
                  <a @click="configure(index)">{{ menuPoint }}</a>
                </li>
              </template>
            </ul>
          </div>
          <div class="col-1">
            <a
              v-if="!isLastVarType"
              @click="nextVarType()"
              class="next-item-arrow"
            >
              <svg width="100%" height="100%" viewBox="0 0 400 100">
                <path
                  xmlns="http://www.w3.org/2000/svg"
                  d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,
                     19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,
                     4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,
                     360.731,229.075z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="container-fluid variation-options">
        <div class="row">
          <div class="col-12">
            <template v-if="selectItems !== false">
              <SelectItems :items="selectItems" :set="set"></SelectItems>
            </template>
            <template v-if="noOptionsFound !== false">
              <div class="text-center" style="margin-top: 4rem">
                <strong>{{ $t("Notifications.noOptionsFound") }}</strong>
              </div>
            </template>
            <template v-if="selectItems === false && possibleItems !== false">
              <DiamondExchange
                v-if="currentVarType == 'stones/diamondExchange'"
                :possibleItems="possibleItems"
                :groupId="groupId"
                :stoneId="stoneId"
              />
              <Variations
                v-else
                :possibleItems="possibleItems"
                :currentVarType="currentVarType"
                :menuList="menuList"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import DAODiamondExchange from "@/assets/DAO/DiamondExchange";
import Notification from "@/assets/Helper/Notification";
import MenuList from "@/assets/Helper/MenuList";
import Logger from "@/assets/Helper/Logger";
import Variations from "@/components/Forms/Variations";
import DiamondExchange from "@/components/Forms/DiamondExchange";
import SelectItems from "@/components/Forms/SelectItems";
import MediaQuery from "@/assets/Helper/MediaQuery";
import Wishlist from "@/assets/Wishlist";
import Slider from "@/assets/Helper/Slider";

export default {
  name: "FormsMain",
  components: { DiamondExchange, Variations, SelectItems },
  props: [],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      menu: false,
      selection: false,
      getApiHost: Config.getters.getApiHost,
      set: SetData.getters.getSet,
      currentItem: SetData.getters.getCurrentItem,
      config: Config.getters.getConfig,
      possibleItems: false,
      groupId: 0,
      stoneId: 0,
      selectItems: false,
      noOptionsFound: false,
      currentVarType: Config.getters.getcurrentVarType,
    };
  },
  methods: {
    configure: function (type) {
      let selectItems = "all";
      let item = SetData.getters.getCurrentItem;
      let itemId = SetData.getters.getCurrentItemId;

      if (SetData.getters.getCurrentItemId === "all") {
        if (this.set.items.length > 1) {
          this.$parent.$parent["setCurrentItem"]("overview");
        } else {
          this.$parent.$parent["setCurrentItem"](0);
        }
      }

      if (
        (history &&
          typeof history.state == "object" &&
          history.state.ispopstate == true) ||
        this.$parent.$parent.$data["resizeTriggered"] === true
      ) {
        this.$parent.$parent.$data["resizeTriggered"] = false;

        history.state.ispopstate = false;

        //Config.dispatch('setVisualMode', 'show');

        Status.dispatch("setLoading", false);
      } else {
        this.$root.$emit("unsetOverview");

        if (type.substr(0, 12) === "stones/group") {
          this.groupId = type.split("/")[2];
          this.stoneId = type.split("/")[3];
          if (item == "overview" || item == "all" || item == "set") {
            let set = SetData.getters.getSet;
            if (
              typeof set.items[0].description.stones.groups[this.groupId] !=
              "object"
            ) {
              type = "stones";
            }
          } else {
            if (
              typeof item.description.stones.groups[this.groupId] != "object" ||
              this.$parent["isCurrentItemBasicModel"](itemId) ||
              (this.menuList &&
                (this.menuList["stones/jewellery/normal"] ||
                  this.menuList["stones/jewellery/model"]))
            ) {
              type = "stones";
            }
          }
        } else if (type === "jewellery/stones") {
          type = "stones";
        }

        this.currentVarType = type;

        if (
          type == "stones" &&
          this.menuList &&
          this.menuList["stones/jewellery/normal"]
        ) {
          type = "stones/jewellery/normal";
          this.currentVarType = type;
          Config.dispatch("setCurrentVarType", type);
        } else {
          Config.dispatch(
            "setCurrentVarType",
            type == "stones" ? "jewellery/stones" : type
          );
        }

        if (item == "overview" || item == "all" || item == "set") {
          selectItems = MenuList.getItemsByVarType(type);

          this.selectItems = selectItems !== "all" ? selectItems : false;
        } else {
          item.description.possibleVariations = MenuList.translateKeys(
            item.description.possibleVariations
          );
          if (
            typeof item.description.possibleVariations == "object" &&
            type.substr(0, 12) !== "stones/group" &&
            type != "stones/diamondExchange" &&
            type != "stones/jewellery/normal" &&
            (typeof item.description.possibleVariations[type] === "undefined" ||
              item.description.possibleVariations[type] !== true)
          ) {
            Config.dispatch("setVisualMode", "show");

            this.currentVarType = "";
            selectItems = false;
          }
        }

        this.menuScrollIntoView();

        if (selectItems === "all") {
          this.selectItems = false;
          if (
            typeof item != "undefined" &&
            typeof type === "string" &&
            type !== ""
          ) {
            Status.dispatch("setLoading", true);
            if (this.config.visualMode !== "images") {
              Config.dispatch("setVisualMode", "conf");
            }

            this.possibleItems = {
              listType: 0,
              list: [],
            };

            this.noOptionsFound = false;

            if (type == "stones/diamondExchange") {
              this.initDiamondStock();
            } else if (type == "engraving") {
              Status.dispatch("setLoading", false);
            } else {
              let itemStr =
                item == "overview" || item == "all" || item == "set"
                  ? SetData.getters.getItemStr
                  : item.itemnumber + ":" + item.size;
              itemStr = this.removeDiamondsFromItemString(itemStr);

              CatchFetch.cacheFirst(
                Config.getters.getApiHostWithLocalStr +
                  "/v2/items/variations/" +
                  type +
                  "/" +
                  itemStr +
                  "/?shop=" +
                  Config.getters.isShopLoginActive
              )
                .then((json) => {
                  this.possibleItems = json;

                  if (
                    (json.list.length < 1 ||
                      (json.list[0] && json.list[0].list.length < 1)) &&
                    type !== "grooves"
                  ) {
                    this.noOptionsFound = true;
                  }
                  Status.dispatch("setLoading", false);
                })
                .catch(() => {
                  Status.dispatch("setLoading", false);
                });
            }
          }
        }

        let currentItemId = SetData.getters.getCurrentItemId;

        if (
          (currentItemId == "overview" || currentItemId == "set") &&
          currentItemId !== "all"
        ) {
          this.$ga.page("/set/" + this.currentVarType);
        } else {
          this.$ga.page(
            "/item/" + (currentItemId + 1) + "/" + this.currentVarType
          );
        }
      }
    },
    initDiamondStock: function () {
      const searchDiamondExchange = SetData.getters.getDiamondExchangeSearch;

      if (
        searchDiamondExchange &&
        typeof searchDiamondExchange.carat === "string"
      ) {
        DAODiamondExchange.getList(
          Config.getters.getCountry,
          searchDiamondExchange["carat"],
          searchDiamondExchange["color"],
          searchDiamondExchange["finish"],
          searchDiamondExchange["polish"],
          searchDiamondExchange["purity"],
          searchDiamondExchange["form"],
          searchDiamondExchange["symmetry"],
          searchDiamondExchange["fluorescence"],
          searchDiamondExchange["certificateNo"],
          searchDiamondExchange["certificate"]
            ? searchDiamondExchange["certificate"].join("-")
            : false,
          searchDiamondExchange["stoneIds"],
          searchDiamondExchange["stoneType"]
        ).then((response) => {
          this.possibleItems = response;
          Status.dispatch("setLoading", false);
        });
      } else {
        let caratSize = this.$parent["getSizeForDiamondExchange"]();
        let stoneform = this.$parent["getStoneformForDiamondExchange"]();
        let purity = this.$parent["getPurityForDiamondExchange"]();
        let stoneType = this.$parent["getStoneTypeForDiamondExchange"]();

        let color = false;
        let finish = false;
        let polish = false;
        let symmetry = null;

        // Cut only for brilliants!
        if (stoneform !== "A") {
          finish = "5_id";
        }

        if (parseInt(stoneType) === 5) {
          color = "9_id";
          finish = "3_id";
          purity = "3_id";
          polish = "3_id";
          symmetry = "3_id";
        }

        if (isNaN(parseFloat(caratSize))) {
          caratSize = "0.3";
        } else {
          caratSize = parseFloat(caratSize);
          const caratRest = parseFloat((caratSize % 0.5).toFixed(1));
          if (
            caratRest !== 0 &&
            caratSize !== 0.3 &&
            caratSize !== 0.4 &&
            caratSize !== 0.7
          ) {
            caratSize = caratSize - caratRest;
          }
        }

        DAODiamondExchange.getList(
          Config.getters.getCountry,
          parseFloat(caratSize).toFixed(1).toString(),
          color,
          finish,
          polish,
          purity,
          stoneform,
          symmetry,
          null,
          null,
          null,
          false,
          stoneType
        ).then((response) => {
          this.possibleItems = response;
          Status.dispatch("setLoading", false);
        });
      }
    },
    removeDiamondsFromItemString: function (itemStr) {
      let itemsAsStones = {};
      for (let j in this.set.items) {
        if (this.set.items[j].description.jewelleryType == 5) {
          itemsAsStones[this.set.items[j].itemnumber] = true;
        }
      }

      let filteredItems = [];
      let counter = 0;
      let items = itemStr.split("_");

      for (let i in items) {
        let posRingSize = items[i].indexOf(":");
        let tmpItemnumber =
          posRingSize >= 0 ? items[i].substr(0, posRingSize) : items[i];
        if (!itemsAsStones[tmpItemnumber]) {
          filteredItems[counter] = items[i];
          counter++;
        }
      }

      return filteredItems.length > 0 ? filteredItems.join("_") : itemStr;
    },
    changeItem: function (itemnumber, alerts) {
      if (
        SetData.getters.getCurrentItem === "all" &&
        typeof SetData.getters.getSetId == "string" &&
        SetData.getters.getSetId !== ""
      ) {
        this.$parent.$parent["setCurrentItem"]("overview");
      }

      if (this.currentVarType !== "metals") {
        this.$parent.$parent["reset3d"](true);
      }

      if (typeof itemnumber == "object") {
        if (itemnumber.length == 1) {
          SetData.dispatch("setItem", { key: false, id: itemnumber[0] });
        } else {
          for (var itemKey in itemnumber) {
            SetData.dispatch("setItem", {
              key: itemKey,
              id: itemnumber[itemKey],
            });
          }
        }
      } else {
        SetData.dispatch("setItem", { key: false, id: itemnumber });
      }

      if (typeof alerts == "object" && alerts.length > 0) {
        Logger.debug("Alerts", alerts);

        for (let key in alerts) {
          Notification.create(alerts[key].title, alerts[key].text);
        }
      } else {
        Logger.debug("No alerts set", alerts);
      }

      if (this.currentVarType == "stones/library") {
        this.currentVarType = "stones";
      }

      this.configure(this.currentVarType);
    },
    changeItemByVarValue: function (varValue) {
      Status.dispatch("setLoading", true);
      let item = SetData.getters.getCurrentItem;

      let itemnumbers = "";
      if (typeof item == "object") {
        itemnumbers = item.itemnumber;
        if (item.size > 0 && itemnumbers.indexOf(":") < 0) {
          itemnumbers += ":" + item.size;
        }
      } else {
        itemnumbers = SetData.getters.getItemStr;
        itemnumbers = itemnumbers.replaceAll("_", "/");
      }

      CatchFetch.cacheFirst(
        Config.getters.getApiHostWithLocalStr +
          "/v2/items/change/" +
          varValue +
          "/" +
          itemnumbers +
          "/"
      )
        .then((json) => {
          if (this.currentVarType == "stones/library") {
            this.currentVarType = "stones";
          }

          if (json.alerts.length > 0) {
            for (let key in json.alerts) {
              Notification.create(
                json.alerts[key].title,
                json.alerts[key].text
              );
            }
          }

          this.changeItem(json.result);
          Status.dispatch("setLoading", false);
        })
        .catch(() => {
          Status.dispatch("setLoading", false);
        });
    },
    backToItem: function () {
      Config.dispatch("setVisualMode", "show").then(() => {
        this.$root.$emit("hideLoader3D");
      });
      window.scrollTo(0, 0);
    },
    menuScrollIntoView: function () {
      /*
      let possibleVariationsSet =
        SetData.getters.getSet.summary.possibleVariations;
      let currentItemId = SetData.getters.getCurrentItemId;

      let menuNode;

      if (
        this.currentVarType.indexOf("stones/group/") > -1 &&
        (!isNaN(currentItemId) || possibleVariationsSet.stones)
      ) {
        menuNode = document.getElementById("menu-" + this.currentVarTypeStone);
      } else {
        if (
          this.currentVarType === "jewellery/stones" ||
          this.currentVarType.indexOf("stones/group/") > -1
        ) {
          this.currentVarType = "stones";
        }
        menuNode = document.getElementById("menu-" + this.currentVarType);
      }

      if (menuNode) {
        setTimeout(() => {
          menuNode.scrollIntoView({ block: "end", inline: "center" });
        });
      }
      */

      if (!MediaQuery.isDesktop() && !Status.getters.isInit) {
        setTimeout(() => {
          document.querySelector(".image-col-right").scrollIntoView();
        }, 250);
      }
      Status.dispatch("setIsInit", false);
    },
    lastVarType: function () {
      let keys = Object.keys(this.fullMenuList);
      this.configure(keys[keys.indexOf(this.currentVarType) - 1]);
    },
    nextVarType: function () {
      let keys = Object.keys(this.fullMenuList);
      this.configure(keys[keys.indexOf(this.currentVarType) + 1]);
    },
    isDesktop() {
      return MediaQuery.isDesktop();
    },
    getStonePositionText: function (group) {
      return this.$parent.getStonePositionText(group);
    },
  },
  created() {
    if (
      Status.getters.isInit === true ||
      Status.getters.getStatus.isLoading === false
    ) {
      this.configure(this.currentVarType);
      if (
        Status.getters.isInit === true &&
        SetData.getters.getShowSetImage === true &&
        this.config.visualMode !== "images"
      ) {
        setTimeout(() => {
          if (this.isDesktop()) {
            if (Wishlist.isRestoredFromWishlist === false) {
              this.$parent.$parent["setCurrentItem"]("set");
            } else {
              this.$parent.$parent["setCurrentItem"]("overview");
            }
          }
        });
      }
    } else {
      Config.dispatch("setVisualMode", "show");
    }
  },
  mounted() {
    this.$root.$on("configure", (type) => {
      if (Config.getters.getcurrentVarType === "jewellery/stones") {
        this.currentVarType = "stones";
      }
      if (typeof type === "undefined" && this.currentVarType != "") {
        type = this.currentVarType;
      }
      if (typeof type === "string" && type !== "") {
        this.configure(type);
      }
    });

    //setTimeout(this.menuScrollIntoView, 100);

    const slider = this.$refs.menuOption;
    Slider.setSlider(slider);
  },
  beforeDestroy() {
    this.$root.$off("configure");
  },
  updated() {
    this.currentItem = SetData.getters.getCurrentItem;
  },
  computed: {
    menuList: function () {
      return MenuList.get(this.set.currentItem);
    },
    isFirstVarType: function () {
      return Object.keys(this.fullMenuList)[0] === this.currentVarType;
    },
    isLastVarType: function () {
      let keys = Object.keys(this.fullMenuList);
      return keys[keys.length - 1] === this.currentVarType;
    },
    fullMenuList: function () {
      let possibleVariationsSet =
        SetData.getters.getSet.summary.possibleVariations;
      let list = JSON.parse(JSON.stringify(this.menuList));

      let currentItem = this.currentItem;
      if (typeof currentItem !== "object" && possibleVariationsSet.stones) {
        currentItem = this.set.items[0];
      }

      if (
        typeof list.stones === "string" &&
        typeof currentItem.description == "object" &&
        typeof currentItem.description.stones == "object"
      ) {
        for (let groupId in currentItem.description.stones.groups) {
          let index = "stones/group/" + groupId + "/0";

          if (currentItem.description.stones.groups[groupId].side !== "top") {
            list[index] =
              this.$t("Menu.var.stoneGroupShort") +
              " " +
              this.getStonePositionText(
                currentItem.description.stones.groups[groupId]
              );
          } else {
            list[index] =
              this.$t("Menu.var.stoneGroupShort") +
              " " +
              currentItem.description.stones.groups[groupId].size.toFixed(3) +
              " ct.";
          }
        }
      }

      return list;
    },
    currentVarTypeStone: function () {
      let currentVarType = Config.getters.getcurrentVarType;

      if (currentVarType.indexOf("stones/group/") > -1) {
        let currentVarTypeParts = currentVarType.split("/");
        let lastItemKey = currentVarTypeParts.length - 1;

        if (currentVarTypeParts[lastItemKey]) {
          let stoneId = currentVarTypeParts[lastItemKey];
          if (!isNaN(stoneId) && stoneId > 0) {
            currentVarTypeParts[lastItemKey] = 0;
            currentVarType = currentVarTypeParts.join("/");
          }
        }
      }
      return currentVarType;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .last-item-arrow,
  .next-item-arrow {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
    cursor: pointer;

    svg {
      width: 1rem;
      height: 7.3rem;
      margin: -1rem 0 0 0;
    }
  }

  .sub-menu {
    overflow-y: hidden;

    ul {
      display: inline-block;
      font-size: 1em;
      list-style: none;
      margin: 0;
      width: max-content;
      white-space: nowrap;

      li {
        list-style: none;
        display: inline-block;
        padding: 1.5rem 2rem;
        line-height: 2em;
        margin: 0 1.5em 0 1.5em;
        cursor: pointer;
        opacity: 0.8;
        letter-spacing: 0.05em;
      }

      li:hover {
        opacity: 1;
        color: $fontColor;

        a {
          text-decoration: none;
        }
      }

      li.match {
        opacity: 1;
        background-color: inherit;
        color: $fontColor;
        border-bottom: solid 0.1rem $black;
        font-weight: bold;

        a {
          color: $fontColor;
        }
      }
    }

    @media (min-width: 1200px) {
      display: none;
    }
  }

  .current-item-name span:first-child {
    text-decoration: underline;
  }

  .current-item.conf-selection {
    .container-menu-options {
      margin-top: 3rem;
      background-color: $darkGrey;
    }

    .variation-options {
      padding: 1.5rem;
    }
  }

  @media (min-width: 768px) {
    .current-item.conf-selection {
      .current-item-name {
        padding-left: 0;
      }

      .current-item-price {
        padding-right: 0;
      }
    }
  }

  @media (min-width: 1200px) {
    .current-item.conf-selection {
      .container-menu-options {
        display: none;
        margin-top: 0;
      }
    }
  }
}
</style>
